import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { NavItems } from "@/components/NavItems";
import { ThemeToggle } from "@/components/ThemeToggle";
import { AuthButtons } from "@/components/AuthButtons";
import { useAuth } from "@/hooks/useAuth";
import { isSSR } from "@/lib/isSSR";

export function MobileMenu() {
  const { isAuthenticated, role } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Remove all console.log statements that were causing the issue

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
      <SheetTrigger asChild>
        <Button variant="outline" size="icon" className="md:hidden">
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left">
        <div className="flex flex-col space-y-4 py-4">
          <ThemeToggle className="self-start ml-2" />

          <NavItems
            isAuthenticated={isAuthenticated}
            userRole={role}
            onItemClick={closeMenu}
            className="flex flex-col space-y-2"
          />

          <AuthButtons
            onNavigate={closeMenu}
            variant="vertical"
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
